import { UiSchema, getUiOptions } from "@rjsf/utils";

/**
 * Utility functions related to react-jsonschema-form
 */
export class RjsfUtils {
  /**
   * Gets all of the string-based options from the current uiSchema
   *
   * @param uiSchema - the current uiSchema
   * @returns - the options of type string
   */
  public static getStringOptions(uiSchema: UiSchema | null | undefined): Record<string, string> {
    if (!uiSchema) {
      return {};
    }

    const uiOptions = getUiOptions(uiSchema);
    const stringOpts: Record<string, string> = {};
    for (const name of Object.keys(uiOptions || {})) {
      const value = uiOptions && uiOptions[name];
      if (value && typeof value === "string") {
        stringOpts[name] = value;
      }
    }

    return stringOpts;
  }
}
